import * as z from 'zod'

export const schemaBoolish = z
    .xor([z.boolean(), z.number().min(0).max(1)])
    .transform((v) => (v === true ? 1 : v === false ? 0 : (v ?? null)))
